import { fromJS } from 'immutable';

export function request(state) {
    return state.set('marketsByEventId', fromJS({
        status: 'IN_PROGRESS'
    }));
}

export function finish(state, { items }) {
    return state.set('marketsByEventId', fromJS({
        status: 'FINISHED',
        items
    }));
}

export function error(state) {
    return state.set('marketsByEventId', fromJS({
        status: 'ERROR'
    }));
}
